import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import SampleTech from 'const/enums/SampleTech';
import validate10x from 'utils/upload/validate10x';
import validateRhapsody from 'utils/upload/validateRhapsody';
import validateSeurat from 'utils/upload/validateSeurat';
import validateH5 from 'utils/upload/validateH5';
import validateParse from 'utils/upload/validateParse';
var sampleValidators = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SampleTech['10X'], validate10x), SampleTech.RHAPSODY, validateRhapsody), SampleTech.SEURAT, validateSeurat), SampleTech.H5, validateH5), SampleTech.PARSE, validateParse);
export default sampleValidators;